import Answers from "../../components/Answers";
function AnswersPage() {
  return (
    <div>
      <Answers />
    </div>
  );
}

export default AnswersPage;
